<template>
  <div id="app">
    <traveller-aside mode="home"></traveller-aside>
    <traveller-header></traveller-header>
    <div class="main-content" v-show="ViewMode === 1">
      <map-view></map-view>
    </div>
    <div class="main-content" v-show="ViewMode === 2">
      <div class="lists-wrapper">
        <rider-list class="t-riderlist"></rider-list>
        <order-list class="t-orderlist"></order-list>
      </div>
      <order-detail-modal
      :orderid="orderDetail.orderid"
      :open="orderDetail.open"
      @close-modal="handleCloseOrderDetailModal"
    ></order-detail-modal>
    </div>
    <time-line
      :time="timestamp"
      @time-change="handleTimeChange">
    </time-line>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import TravellerAside from 'components/TravellerAside';
import TravellerHeader from 'components/TravellerHeader';
import OrderDetailModal from 'components/OrderDetailModal';
import { throttle } from 'common/utils';
import TimeLine from 'components/TimeLine';
import RiderList from './modules/RiderList';
import OrderList from './modules/OrderList';
import MapView from './modules/MapView';
import { UPDATE_ORDER_DETAIL, UPDATE_TIMESTAMP } from './store/mutation-types';

export default {
  name: 'App',
  components: {
    TravellerAside,
    TravellerHeader,
    TimeLine,
    OrderDetailModal,
    RiderList,
    OrderList,
    MapView,
  },
  computed: {
    ...mapState(['orderDetail', 'timestamp']),
    ...mapState({
      ViewMode: ({ aside }) => aside.ViewMode,
    }),
  },
  created() {
    this.handleTimeChange = throttle((timestamp) => {
      this.updateTime(timestamp);
    }, 100);
  },
  watch: {
  },
  methods: {
    ...mapActions(['getInitData']),
    ...mapMutations({
      updateAside: 'setAsideState',
      updateOrderDetail: UPDATE_ORDER_DETAIL,
      updateTime: UPDATE_TIMESTAMP,
    }),
    handleCloseOrderDetailModal() {
      this.updateOrderDetail({
        open: false,
        oriderid: '',
      });
    },
  },
  mounted() {
    this.getInitData();
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #f6f6f6;
  font-size: 12px;

  .lists-wrapper {
    display: flex;
    min-height: 300px;
    height: calc(100% - 90px);
    padding: 68px 0 0px 176px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homepage/App.vue